document.addEventListener('DOMContentLoaded', function() {
  
  let currentOpenDropdown = null;
  let isProcessing = false;
  
  function openDropdown(wrapper) {
    const dropdown = wrapper.querySelector('[data-dropdown-menu]');
    wrapper.classList.add('open');
    dropdown.classList.add('show');
    currentOpenDropdown = wrapper;
  }
  
  function closeDropdown(wrapper) {
    if (!wrapper) return;
    const dropdown = wrapper.querySelector('[data-dropdown-menu]');
    wrapper.classList.remove('open');
    dropdown.classList.remove('show');
    currentOpenDropdown = null;
  }
  
  document.addEventListener('click', function(e) {
    
    if (e.target.closest('[data-option-item]')) {
      if (isProcessing) return;
      
      const item = e.target.closest('[data-option-item]');
      const wrapper = item.closest('[data-select-wrapper]');
      
      if (item.classList.contains('muq-disabled')) return;
      
      isProcessing = true;
      
      const value = item.dataset.value;
      const text = item.querySelector('.select-variant-dy').textContent;
      
      const placeholder = wrapper.querySelector('[data-select-placeholder]');
      placeholder.textContent = text;
      
      const hiddenSelect = wrapper.parentElement.querySelector('select[data-minimog-select]');
      hiddenSelect.value = value;
      
      const label = wrapper.closest('.m-product-option').querySelector('.option-label--selected');
      if (label) label.textContent = text;
      
      closeDropdown(wrapper);
      
      setTimeout(() => {
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(() => {
          isProcessing = false;
        }, 200);
      }, 100);
      
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    
    if (e.target.closest('[data-select-display]') || e.target.closest('[data-select-trigger]')) {
      if (isProcessing) return;
      
      const wrapper = e.target.closest('[data-select-wrapper]');
      
      if (currentOpenDropdown && currentOpenDropdown !== wrapper) {
        closeDropdown(currentOpenDropdown);
      }
      
      if (currentOpenDropdown === wrapper) {
        closeDropdown(wrapper);
      } else {
        openDropdown(wrapper);
      }
      
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    
    if (currentOpenDropdown && !e.target.closest('[data-select-wrapper]')) {
      closeDropdown(currentOpenDropdown);
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (currentOpenDropdown) {
        closeDropdown(currentOpenDropdown);
      }
    }
  });
  
});